import { Component, Input } from '@angular/core';
import {
  BaseProperties,
  CSSProperties,
  DynamicBannerConfiguration,
  DynamicBannerContent,
  DynamicBannerStyleProperties
} from '../../../models';

/**
 * This component is responsible to display full image banner with custom
 * configuration regarding device settings and styling
 */
@Component({
  selector: 'idp-banner-fullimage',
  templateUrl: './banner-fullimage.component.html',
  styleUrls: ['./banner-fullimage.component.scss']
})
export class BannerFullimageComponent
  implements
    BaseProperties<
      DynamicBannerConfiguration,
      DynamicBannerContent,
      DynamicBannerStyleProperties
    >
{
  /** This props holds all content regarding full image banner */
  @Input() content: DynamicBannerContent = {} as DynamicBannerContent;
  /**
   * This is the primary configuration for full image banner.
   * You can pass several configuration like device configuration and template configuration
   */
  @Input() config: DynamicBannerConfiguration =
    {} as DynamicBannerConfiguration;

  /** This holds style properties. You can set apply styling according to the use case. */
  @Input() styles: DynamicBannerStyleProperties =
    {} as DynamicBannerStyleProperties;

  constructor() {
    /** Set default properties for config, content and styles */
    this.config = {
      deviceConfig: {
        desktopEnabled: true,
        mobileEnabled: true
      },
      templateType: 'fullimagebanner'
    };
    this.content = {
      imageContent: {
        desktop: {
          src: '',
          alt: ''
        },
        mobile: {
          src: '',
          alt: ''
        },
        tablet: {
          src: '',
          alt: ''
        }
      }
    };
    this.styles = {
      banner: {
        borderColor: '',
        backgroundColor: ''
      }
    };
  }

  /** prepare container styles for full image banner */
  get containerStyles(): CSSProperties {
    return this.styles.banner || ({} as CSSProperties);
  }

  /** check desktop enable setting is turned on or not */
  get desktopEnabled(): boolean {
    return this.config.deviceConfig.desktopEnabled || false;
  }

  /** check mobile enable setting is turned on or not */
  get mobileEnabled(): boolean {
    return this.config.deviceConfig.mobileEnabled || false;
  }
}
